export const actions = {
  RECLAMACIONES_LOAD_REQUESTED: 'RECLAMACIONES_LOAD_REQUESTED',
  RECLAMACIONES_LOAD_SUCCEEDED: 'RECLAMACIONES_LOAD_SUCCEEDED',
  RECLAMACIONES_LOAD_FAILED: 'RECLAMACIONES_LOAD_FAILED',
}

export const getReclamacionesAction = (dispatch, payload) => {
  dispatch({
    type: actions.RECLAMACIONES_LOAD_REQUESTED,
    payload,
  })
}
